import { render, staticRenderFns } from "./AbstractType.vue?vue&type=template&id=6fbbe31b&scoped=true"
import script from "./AbstractType.vue?vue&type=script&lang=js"
export * from "./AbstractType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbe31b",
  null
  
)

export default component.exports